import { render, staticRenderFns } from "./CrearFaltante.vue?vue&type=template&id=1e24c1ab"
import script from "./CrearFaltante.vue?vue&type=script&lang=js"
export * from "./CrearFaltante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports